import { HStack, token } from '@terra/ui-styled-system';
import { HelpCircleIcon } from '@terra/ui-icons';
import { Tooltip } from '../../components/tooltip';
import { BodyDefault } from '../../components/typography';

export type AutomationFieldLabelProps = {
  label: string;
  tooltipTitle: string;
};

export const AutomationFieldLabel = ({
  label,
  tooltipTitle,
}: AutomationFieldLabelProps) => (
  <HStack gap={2} alignItems="center">
    <BodyDefault color="fg.neutral.muted">{label}</BodyDefault>
    <Tooltip title={tooltipTitle} positioning={{ strategy: 'fixed' }}>
      <span>
        <HelpCircleIcon
          size={16}
          color={token('colors.fg.neutral.muted')}
          aria-hidden
        />
      </span>
    </Tooltip>
  </HStack>
);
